<template>
  <div>
    <NavBar
      title="选择登录方式"
      class="block"
    />
    <Button type="info" block class="block" @click="login('cas')">数字杭电登录</Button>
    <Button type="info" block class="block" @click="login('wxmp')">微信登录</Button>
    <p class="bottom-msg">如果有问题请加入杭电助手答疑群 551292799 解决</p>
  </div>
</template>

<script>
import { NavBar, Button } from 'vant';
import axios from 'axios'
export default {
  name: 'Choose',
  components: {
    NavBar,
    Button
  },
  methods: {
    async login(method) {
      const casUrlRes = (await axios.get(`/login/url/${method}`, {
          params: {
            clientID: 'dingtalkuser',
            redirect: `${window.location.origin}/#/auth`
          }
        })).data
      const redirectURL = casUrlRes.data.url
      window.location.href = redirectURL
    }
  }
}
</script>

<style scoped>
.block {
  margin-bottom: 26px;
}
</style>